const firebaseConfig = {
  apiKey: "AIzaSyBdhFhveBftIGGW1PQDXXc36sdRJDNa5HM",
  authDomain: "ghosh-hospital.firebaseapp.com",
  projectId: "ghosh-hospital",
  storageBucket: "ghosh-hospital.appspot.com",
  messagingSenderId: "616804311067",
  appId: "1:616804311067:web:a4015ba2254275086298be",
  measurementId: "G-6PHM2CC97V"
};
export default firebaseConfig;